module Meevo.Plugins.Tippy {
    "use strict";

    /**
    * Main Section of Field Labels
    */
    export class MainSection extends Meevo.Components.CommonClasses.CommonSectionBase {
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            private modalService: Meevo.Components.Modal.IModalService,
            private tippyService: Meevo.Plugins.Tippy.TippyService,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey)
        }

        canSaveLogic(): boolean {
            let regexp = new RegExp('^[a-zA-Z0-9]{16,16}$');
            if (this.model.accountToken && !regexp.test(this.model.accountToken)) {
                this.modalService.alert("MESSAGE_TIPPY_INVALID_ACCOUNT_TOKEN");
                return false;
            }
            return super.canSaveLogic();
        }

        enabledFlagChanged() {
            if (!this.model.isTipProcessingEnabled && !this.originalEntity.accountToken) {
                this.modalService.alert("MESSAGE_TIPPY_ACCOUNT_CANNOT_ENABLE").then(() => {
                    this.model.isTipProcessingEnabled = false;
                });
            }
        }
    }
}